import { render, staticRenderFns } from "./AIVButton.vue?vue&type=template&id=5a4a24c0"
import script from "./AIVButton.vue?vue&type=script&lang=js"
export * from "./AIVButton.vue?vue&type=script&lang=js"
import style0 from "./AIVButton.vue?vue&type=style&index=0&id=5a4a24c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports